export class DefendantModel {
    name: string;
    loanNo: string;
    icNo: string;
    status: string;
}